import React, {
  Dispatch,
  FC,
  SetStateAction,
  useState,
  useEffect,
} from 'react';
import { Switch } from '@headlessui/react';
import ErrorMessage from '../error-message/error-message';

export interface NormalToggleProps {
  className?: string;
  label?: string;
  onChange: Dispatch<SetStateAction<Boolean>>;
  toggled?: boolean;
  name?: string;
  errors?: any;
  errorMessage?: string;
  isValid?: boolean;
  [x: string]: any;
}

const normalStyle = `w-[43px] h-[28.5px] relative inline-flex flex-shrink-0 items-center
rounded-full cursor-pointer transition-colors ease-in-out`;

const labelStyle =
  'ml-[10px] font-open-sans font-normal text-form-text text-thryv-black-500 capitalize';

const innerSwitchStyle =
  'w-[20px] h-[20px] bg-white pointer-events-none inline-block rounded-full';

export const NormalToggle: FC<NormalToggleProps> = ({
  className,
  label,
  onChange,
  toggled = false,
  name,
  errors,
  errorMessage,
  isValid,
  ...rest
}: NormalToggleProps) => {
  const [enabled, setEnabled] = useState<boolean>(toggled);

  useEffect(() => setEnabled(toggled), [toggled]);

  return (
    <div>
      <Switch.Group>
        <div className={`${className} flex items-center`}>
          <Switch
            {...rest}
            checked={enabled}
            name={name}
            onChange={(e: any) => {
              onChange && onChange(e);
              setEnabled(e);
            }}
            className={` 
            ${normalStyle} 
            ${
              enabled
                ? (rest.disabled && 'bg-thryv-gray-light-500') ||
                  'bg-thryv-black-500'
                : `bg-thryv-gray-light-500`
            }
            transition-all ease-in-out duration-400
        `}
          >
            <span className="sr-only">Use setting</span>
            <span // This is where the round inner switch is
              aria-hidden="true"
              className={`
              ${innerSwitchStyle}
              ${enabled ? 'translate-x-[18px]' : 'translate-x-[5px]'}
              transition-all ease-in-out duration-400
            `}
            />
          </Switch>
          {label ? (
            <Switch.Label className={labelStyle} passive>
              {label}
            </Switch.Label>
          ) : null}
        </div>
      </Switch.Group>
      {errors && name && errors[name] && errors[name].message && (
        <ErrorMessage errorMessage={errors[name].message} />
      )}
      {!isValid && <ErrorMessage errorMessage={errorMessage} />}
    </div>
  );
};
